import { Tabs, Divider, Button, Card } from 'antd';
import { CalendarOutlined,CodeOutlined, ProfileOutlined,CloseOutlined ,RocketOutlined ,AppstoreAddOutlined, EllipsisOutlined} from '@ant-design/icons';
import YourJobsAll from '../YourJobsAll';
import YourJobsPerformance from './YourJobPerformance';
import JobboardBoosts from './JobboardBoosts';
import { useState,useEffect, useContext } from 'react';
import WebLinks from '../../api/WebLinks';
import Cookies from 'js-cookie';
import constants from '../../constants/constants';
import APIUtils from '../../api/APIUtils';
import YourJobsMaxApps from './YourJobsMaxApps';
import JobBoardBoostsSelfService from './JobBoardBoostsSelfService';
import JobsAutomateBoosts from './JobsAutomateBoosts';
import { CommonContext } from '../../Context';
import { trackPageAccess } from '../../globalFunctions/GlobalFunctions';
import Topup from '../common/TopUp';
const { TabPane } = Tabs;

const YourJobsContainer = (props) => {
 
  //Start:For Testing only(Remove once JobboardBoost is fully complete)
  const commonContext=useContext(CommonContext);
  const buyerId = commonContext.common.buyerId;
  const [loader,setLoader]=useState(false);
  const [showBoost,setShowBoost]=useState(false);
  const isSelfService= sessionStorage.getItem('isSelfService');
  const [selfService,setSelfService]=useState(false);
  const [openPopover, setOpenPopover]=useState(false);
  const [isTopupOpen, setIsTopupOpen] = useState(false);
  const [activeTab, setActiveTab] = useState(props?.location?.state?.activeTab || (isSelfService===true||isSelfService==='true'||selfService===true ? '3' : '1'));
  const instructionsItems= [
    {
      key: '1',
      label: 'Buy Credits',
      content: 
        <div className="space-y-4 leading-6">
          <ul className="list-disc pl-5 space-y-2">
            <li>
              First thing to do is to use the Top Up link at the top of the page or{" "}
              <Button
                type="link"
                onClick={() => setIsTopupOpen(true)}
                className="text-blue-600 hover:underline hover:text-blue-600 !p-0 !h-auto align-baseline"
              >Click Here</Button>{" "}
              to buy some credits which can be used to boost your jobs on
              Indeed, Linkedin, Job Boards and Social Media.
            </li>
            <li>
              Your Credit balance will be updated at the top of the page.
            </li>
          </ul>
      </div>
    },
    {
      key: '2',
      label: 'Boost Your Jobs',
      content:
        <div className="space-y-4 leading-6">
          <ol className="list-decimal pl-4 space-y-3">
            <li>Make sure you have some credits. If not then <Button
              type="link"
              onClick={() => setIsTopupOpen(true)}
              className="text-blue-600 hover:underline hover:text-blue-600 !p-0 !h-auto align-baseline"
            >
              Top Up
            </Button> your Credits.</li>
          <li>Go to Boost Your Jobs menu option and add the job(s) you want to boost to the Basket using the ‘add to basket’ buttons. </li>
          <li>View Basket and select which Indeed, LinkedIn and other job boards you would like to boost the job(s) onto. We will display all available boosting options, with recommended options shown first.</li>
          <li>Once you have selected them click the Buy Selected Products button and confirm the purchase.</li>
          <li>Your Order will now show in the Boost Orders tab and will be processed.</li>
          <li>The Boost Your Jobs page shows the Application count for each job that has come through our system and for more detailed reporting you can look at the Application Reports tab.</li>
        </ol>
      </div>
    },
    {
      key: '6',
      label: 'Support',
      content:
        <div className="space-y-3 leading-6">
          <ul className="list-disc pl-5 space-y-2">
            <li>Use this support form or the Support Chat Bot on the bottom left.</li>
          </ul>
        </div>
    },
  ];
  

  useEffect(() => {
    trackPageAccess(buyerId,window.location.href)
    getBuyerDetails();
  }, []);

  const getBuyerDetails = async () => {
    setLoader(true);
    const response = await APIUtils.apiCall('GET', WebLinks.GetBuyerDetails + buyerId);
    if (!response.isCatch && response.resultObj?.statusCode === "2000") {
      setShowBoost(response.resultObj?.data?.showBoost);
      setSelfService(response.resultObj?.data?.selfService);
      setLoader(false);
    } else {
      setLoader(false);
    }
  };
  const showInstructionsButton =
    (showBoost === "true" || showBoost === true) &&
    (selfService === false || selfService === "false");
  const renderInstructionsButton = (className) => (
    <Button
      type="primary"
      className={className}
      onClick={() =>
        setOpenPopover(
          openPopover === 'instructions' ? null : 'instructions'
        )
      }
    >
      Job Board / LinkedIn Boost Instructions
    </Button>
  );
  //End
	//Render
	return (
		<div>
      {/* <div className='uppercase font-bold text-xl'>Your Jobs</div> */}
			{/* <Divider className='my-3'/> */}
      {showInstructionsButton && (
        <div className="mb-3 md:hidden">
          {renderInstructionsButton("w-full whitespace-normal h-auto")}
        </div>
      )}
      {isSelfService===true||isSelfService==="true"||selfService===true?
      <Tabs activeKey={activeTab} onChange={setActiveTab} moreIcon={<EllipsisOutlined />} tabBarExtraContent={
      showInstructionsButton?
      <div className="hidden items-center md:flex">
        {renderInstructionsButton()}
      </div>:null
    }>
      {/* {showBoost? */}
      <TabPane
        tab={ <span className='uppercase whitespace-nowrap'><RocketOutlined className='text-xl' />Buy Jobboard boosts</span> }
        key={3}
      >
        <JobBoardBoostsSelfService/>
      </TabPane>
      {/* :null} */}
      {showBoost?
      <TabPane
        tab={ <span className='uppercase whitespace-nowrap'><CodeOutlined className='text-xl' />Automate boosts</span> }
        key={4}
      >
        <JobsAutomateBoosts/>
      </TabPane> :null}
			</Tabs>
			:
			<Tabs activeKey={activeTab} onChange={setActiveTab} moreIcon={<EllipsisOutlined />} tabBarExtraContent={
			showInstructionsButton?
			<div className="hidden items-center md:flex">
			  {renderInstructionsButton()}
			</div>
			:null}>
			<TabPane
        tab={ <span className='uppercase whitespace-nowrap'><CalendarOutlined className='text-xl' />Your Jobs</span> }
        key={1}
      >
        <YourJobsAll/>
      </TabPane>
			<TabPane
        tab={ <span className='uppercase whitespace-nowrap'><ProfileOutlined className='text-xl' />Performance</span> }
        key={2}
      >
        <YourJobsPerformance/>
      </TabPane>
      <TabPane
        tab={ <span className='uppercase whitespace-nowrap'><AppstoreAddOutlined className='text-xl' />max apps</span> }
        key={4}
      >
        <YourJobsMaxApps/>
      </TabPane>
      {showBoost?
      <>
      <TabPane
        tab={ <span className='uppercase whitespace-nowrap'><RocketOutlined className='text-xl' />Buy Jobboard boosts</span> }
        key={3}
      >
        <JobboardBoosts/>
      </TabPane>
      <TabPane
        tab={ <span className='uppercase whitespace-nowrap'><CodeOutlined className='text-xl' />Automate boosts</span> }
        key={5}
      >
        <JobsAutomateBoosts/>
      </TabPane>
      </>
      :null}
			</Tabs>}
      {openPopover === 'instructions' && (
        <div
            className="
              instruction-popup
              fixed
              bottom-2 sm:bottom-2 lg:bottom-2
              right-2 sm:right-4 lg:right-5
              w-[95vw]
              sm:w-[90vw]
              md:w-[680px]
              lg:w-[970px]
              z-[9999]
            "
          >
            <Card
              className="rounded-lg shadow-2xl border overflow-hidden"
              bodyStyle={{
                padding: 0,
                display: "flex",
                flexDirection: "column",
                height: "41vh",
              }}
            >
              <div className="flex items-center justify-between px-4 py-2 border-b text-white" style={{ backgroundColor: '#00B2A8' }}>
                <div>
                  <h2 className="text-base font-semibold m-0 leading-5">
                    {constants.Instructions}
                  </h2>
                </div>
                <Button
                  type="text"
                  icon={<CloseOutlined />}
                  className='text-white'
                  onClick={() => setOpenPopover(null)}
                />
              </div>
              <div className="px-4 py-3 overflow-hidden">
                <Tabs
                  className="instruction-tabs"
                  tabPosition="left"
                  destroyInactiveTabPane
                  items={instructionsItems.map((tab) => ({
                    key: tab.key,
                    label: (
                      <span>
                        {tab.label}
                      </span>
                    ),
                    children: (
                      <div
                        className="h-full overflow-y-auto"
                      >
                        <div className="bg-gray-50 border border-gray-100 rounded-lg p-2">
                          {tab.content}
                        </div>
                      </div>
                    ),
                  }))}
                />
              </div>
            </Card>
        </div>
      )}
      {isTopupOpen &&
              <Topup
                open={isTopupOpen}
                setOpen={setIsTopupOpen}
      />}
		</div>
	);
};

export default YourJobsContainer;